import React from "react";
import { TabContent, TabPane } from "reactstrap";

// hooks
import { useRedux } from "../../hooks/index";
import { createSelector } from "reselect";
// constants
import { TABS, WpModes } from "../../constants/index";

// component
import Profile from "./Profile/index";
import Chats from "./Chats/index";
import WorkPlace from "./Workplace/index";
import Contacts from "./Contacts/index";
import Calls from "./Calls/index";
import Bookmark from "./Bookmark/index";
import Settings from "./Settings/index";
import TestLazyLoad2 from "./Test/TestLazyLoad2";
import TestHugeChatRoom from "./Test/TestHugeChatRoom";
import TestSImpleBar from "./Test/TestSimpleBar";
import TestCode from "./Test/TestCode";
import Setting2s from "./Settings/Setting2s";
import { WpSliceData } from "redux/workplace/wpTypes";
import { UserTypes } from "api";
import ApprovalList from "./Approval/ApprovalList";

interface LeftbarProps { }
const Leftbar = (props: LeftbarProps) => {
  // global store
  const { useAppSelector } = useRedux();

  // const { activeTab } = useAppSelector(state => ({
  //   activeTab: state.Layout.activeTab,
  // }));
  const errorData = createSelector(
    (state: any) => state.Layout,
    (state: any) => state.WpSlice,
    (state, wp: WpSliceData) => ({
      activeTab: state.activeTab,
      isInFrame: state.isInFrame,
      isEmbChatOnly: wp.isEmbChatOnly,
    })
  );
  // Inside your component
  const { activeTab, isInFrame, isEmbChatOnly } = useAppSelector(errorData);

  //const cssContainer = activeTab == TABS.WORKPLACE
  const cssContainer = (activeTab == TABS.WORKPLACE || activeTab == TABS.TASK || activeTab == TABS.APPROVAL)
    ? ("workplace-leftsidebar" + (isEmbChatOnly ? " hide" : ""))
    : ("chat-leftsidebar" + (isInFrame ? " chat-leftsidebar-hide" : ""));

  return (
    <>
      {/* start chat-leftsidebar */}
      <div className={cssContainer}>
        <TabContent activeTab={activeTab}>
          {/* Start Profile tab-pane */}
          <TabPane tabId={TABS.USERS} role="tabpanel" ><Profile /></TabPane>

          <TabPane tabId={TABS.CHAT} role="tabpanel" >
            <Chats groupType={UserTypes.Group} />
          </TabPane>

          <TabPane tabId={TABS.CHAT_SUP} role="tabpanel">
            <Chats groupType={UserTypes.GroupSupplier} />
          </TabPane>

          <TabPane tabId={TABS.CONTACTS} role="tabpanel"><Contacts /></TabPane>

          <TabPane tabId={TABS.CALLS} role="tabpanel"><Calls /></TabPane>

          <TabPane tabId={TABS.BOOKMARK} role="tabpanel"><Bookmark /></TabPane>

          <TabPane tabId={TABS.SETTINGS} role="tabpanel"><Settings /></TabPane>

          <TabPane tabId={TABS.TEST} role="tabpanel"><TestCode /></TabPane>

          <TabPane tabId={TABS.WORKPLACE} role="tabpanel"><WorkPlace wpMode={WpModes.Workplace} /></TabPane>

          <TabPane tabId={TABS.TASK} role="tabpanel"><WorkPlace wpMode={WpModes.Task} /></TabPane>

          <TabPane tabId={TABS.APPROVAL} role="tabpanel"><ApprovalList /></TabPane>

        </TabContent>
      </div>
    </>
  );
};

export default Leftbar;
